import angular from 'angular';
import header from './header.directive';
import { menuitem } from './menuitem/header.menuitem.component';
import { avatar } from '../avatar/avatar.component';

export default angular
    .module('header', [])
    .directive('vlHeader', header)
    .component('vlAvatar', avatar)
    .component('vlMenuItem', menuitem).name;